module.exports = __webpack_public_path__ + "static/media/savePoint.ca15287b.svg";